// extracted by mini-css-extract-plugin
module.exports = {"applePayButton":"_1Fppen","titleBuy":"_1byyxj","titleSetup":"_1yk0T0"};